"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFooterLinks = exports.renderGlobalMenus = exports.renderHeaderMenus = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var ColumnMenu_1 = __importDefault(require("../Header/Helpers/ColumnMenu"));

var StructuredColumnMenu_1 = __importDefault(require("../Header/Helpers/StructuredColumnMenu"));

var StaticItem_1 = __importDefault(require("../common/StaticItem"));

var Utils_1 = require("../Header/Helpers/Utils");

var StyledComponents_1 = require("./StyledComponents");

var frontend_common_1 = require("@ryerson/frontend.common");

var Utils_2 = require("../Header/Helpers/Utils");

var Constants_1 = require("../common/Constants");

var renderHeaderMenus = function renderHeaderMenus(headerMenus, mobileBreakPoint, windowSize, theme, getMenuObj, doNavigation, bodyClicked, bodyBindClick, bodyUnbindClick, navigate, openUtilMenu, language, setOpenUtilMenu, setSelectedProductMenuId, headerSettings, storeDirectory) {
  var secondaryBrand = theme.colors.primary.secondaryBrand;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "global-menus",
      justifyContent: "space-between",
      style: (0, StyledComponents_1.globalNavMenuStyles)(mobileBreakPoint, headerSettings.globalMenus.containerWidth(language)),
      dataTestId: "global-menus",
      children: [headerMenus && headerMenus.map(function (headerMenu, index) {
        return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          alignSelf: "center",
          children: (0, jsx_runtime_1.jsx)(StructuredColumnMenu_1.default, {
            breakPoint: mobileBreakPoint,
            width: headerMenu.column1Links && headerMenu.column1Links.length > 0 && headerMenu.column2Links && headerMenu.column2Links.length > 0 && headerMenu.column3Links && headerMenu.column3Links.length > 0 ? 890 : headerMenu.column1Links && headerMenu.column1Links.length > 0 && headerMenu.column2Links && headerMenu.column2Links.length > 0 ? 580 : 370,
            addLeftOffset: index === 2 ? -140 : index === 1 ? -50 : -80,
            menuTop: 58,
            disabled: headerMenu.column1Links.length > 0 ? false : true,
            menuText: headerMenu.label,
            menuName: headerMenu.label,
            menuData: [headerMenu.column1Links, headerMenu.column2Links, headerMenu.column3Links],
            dividerStyle: "line",
            isExpanded: openUtilMenu === headerMenu.label,
            handleMenuItemClicked: function handleMenuItemClicked(menuName, val) {
              val && storeDirectory === Constants_1.STORE ? navigate(val) : window.location.href = val;
              setOpenUtilMenu("");
              document && bodyUnbindClick(bodyClicked);
            },
            handleMenuOpen: function handleMenuOpen(menuName) {
              var isOpen = openUtilMenu === headerMenu.label;
              document && bodyBindClick(bodyClicked);
              !isOpen && setSelectedProductMenuId("");
              setOpenUtilMenu(isOpen ? "" : menuName);
            }
          })
        }, "global-".concat(index));
      }), headerSettings.globalMenus.showStockList && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          breakPoint: mobileBreakPoint,
          itemName: "getStocklist",
          color: secondaryBrand,
          returnType: "link"
        })
      })]
    })
  });
};

exports.renderHeaderMenus = renderHeaderMenus;

var renderGlobalMenus = function renderGlobalMenus(globalMenus, mobileBreakPoint, windowSize, theme, getMenuObj, doNavigation, bodyClicked, bodyBindClick, bodyUnbindClick, navigate, openUtilMenu, language, setOpenUtilMenu, setSelectedProductMenuId, headerSettings, storeDirectory) {
  var secondaryBrand = theme.colors.primary.secondaryBrand;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "global-menus",
      justifyContent: "space-between",
      style: (0, StyledComponents_1.globalNavMenuStyles)(mobileBreakPoint, headerSettings.globalMenus.containerWidth(language)),
      children: [globalMenus && globalMenus.map(function (globalMenu, index) {
        return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(ColumnMenu_1.default, {
              breakPoint: mobileBreakPoint,
              width: (0, Utils_1.getGlobalMenuWidth)(globalMenu.name, windowSize, mobileBreakPoint),
              addLeftOffset: windowSize && (0, Utils_1.getGlobalMenuLeftOffset)(globalMenu.name, windowSize, mobileBreakPoint),
              menuTop: 58,
              disabled: !globalMenu.active,
              menuText: globalMenu.display,
              menuName: globalMenu.name,
              menuData: globalMenu.items,
              dividerStyle: "line",
              columnFooter: function columnFooter(colIndex, colId) {
                return (0, exports.renderFooterLinks)(colIndex, globalMenu.name, getMenuObj, doNavigation, theme, mobileBreakPoint, language, colId);
              },
              isExpanded: openUtilMenu === globalMenu.name,
              handleMenuItemClicked: function handleMenuItemClicked(menuName, val) {
                val && storeDirectory === Constants_1.STORE ? navigate(val) : window.location.href = val;
                setOpenUtilMenu("");
                document && bodyUnbindClick(bodyClicked);
              },
              handleMenuOpen: function handleMenuOpen(menuName) {
                var isOpen = openUtilMenu === globalMenu.name;
                document && bodyBindClick(bodyClicked);
                !isOpen && setSelectedProductMenuId("");
                setOpenUtilMenu(isOpen ? "" : menuName);
              }
            })
          })
        }, "global-".concat(index));
      }), headerSettings.globalMenus.showStockList && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          breakPoint: mobileBreakPoint,
          itemName: "getStocklist",
          color: secondaryBrand,
          returnType: "link"
        })
      })]
    })
  });
};

exports.renderGlobalMenus = renderGlobalMenus;
/*
 @description - In Global Menu Specific: columns get footer link (note this is for Global Menu)
 a column inside the menu can have a footer section
 */

var renderFooterLinks = function renderFooterLinks(colIndex, menuName, getMenuObj, doNavigation, theme, mobileBreakPoint, language, colId) {
  var _a, _b, _c;

  if (menuName === "whyRyerson" && colId === Utils_2.columnId.CUSTOMIZED_SOLUTIONS_ID) {
    return (0, Utils_2.renderColFooterLink)(theme, mobileBreakPoint, frontend_common_1.withTranslation["whyRyerson"][language], "flex-end", function () {
      doNavigation("whyRyerson");
    }, (_a = getMenuObj("whyRyerson")) === null || _a === void 0 ? void 0 : _a.active, -4);
  } else if (menuName === "metalSolutions" && colId === Utils_2.columnId.SOlUTIONS_ID) {
    return (0, Utils_2.renderColFooterLink)(theme, mobileBreakPoint, frontend_common_1.withTranslation["allMetalSolutions"][language], "flex-end", function () {
      doNavigation("metalSolutions");
    }, (_b = getMenuObj("metalSolutions")) === null || _b === void 0 ? void 0 : _b.active, -2);
  } else if (menuName === "metalResources" && colId === Utils_2.columnId.MARKET_INTEL_ID) {
    return (0, Utils_2.renderColFooterLink)(theme, mobileBreakPoint, frontend_common_1.withTranslation["allMetalResources"][language], "center", function () {
      doNavigation("metalResources");
    }, (_c = getMenuObj("metalResources")) === null || _c === void 0 ? void 0 : _c.active, 5);
  } else {
    return null;
  }
};

exports.renderFooterLinks = renderFooterLinks;